export enum SampleCensorType {
    GreaterThan = 0,
    LessThan = 1,
    Equal = 2,
    NA = 3
}

export enum SampleCensorSign {
    '>' = SampleCensorType.GreaterThan,
    '<' = SampleCensorType.LessThan,
    '=' = SampleCensorType.Equal,
    'N/A' = SampleCensorType.NA
}